import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { ButtonBase } from './button.base'

@Component({
  standalone: true,
  selector: 'button[ftrButton]',
  styleUrls: ['./button.component.css'],
  template: '<ng-content></ng-content>',
  exportAs: 'ftrButton',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends ButtonBase {}
